import type { ReservationPartyLookupDto } from '../Types/reservationTypes';

export type ReservationPartySourceType = 'party-api';

export interface ReservationPartyLookup {
  id: number;
  label: string;
  email: string;
  phone: string;
  taxId: string;
  addressSummary: string;
  sourceType: ReservationPartySourceType;
}

const normalizeValue = (value: string | undefined | null): string => value?.trim() ?? '';

export const mapReservationPartyDtoToLookup = (
  dto: ReservationPartyLookupDto | undefined | null
): ReservationPartyLookup | undefined => {
  if (!dto) {
    return undefined;
  }

  const email = normalizeValue(dto.email);
  const phone = normalizeValue(dto.phone);
  const taxId = normalizeValue(dto.taxId);
  const addressSummary = normalizeValue(dto.addressSummary);
  const label = normalizeValue(dto.displayName) || `Party #${dto.id}`;

  return {
    id: dto.id,
    label,
    email,
    phone,
    taxId,
    addressSummary,
    sourceType: 'party-api',
  };
};
